// extracted by mini-css-extract-plugin
module.exports = {"form":"dinamicform_form__3ht23","required":"dinamicform_required__1ohbz"};